const styles = {
  root: {
    height: '100vh',
    overflow: 'auto',
    paddingBottom: 120,
    boxSizing: 'border-box',
  },
};

export default styles;
